module.exports = __webpack_public_path__ + "img/facebook.d10f4d45.svg";